import { media, P, Tile } from 'ia-react-core';
import styled from 'styled-components';

export const StyledTile = styled(Tile)`
  :last-child {
    margin-bottom: 16px;
  }
  ${media.lg`
    :last-child {
      margin-bottom: 0;
    }
  `};
`;

export const StyledLinePrompt = styled(P)`
  margin: 20px 26px 0px 0px;
  font-size: 12px;
  line-height: 1.17;
  ${media.lg`
    margin-left: 12px;
  `};
`;
